import React, { Component } from 'react';
import Select from 'react-select';
import CreatableSelect from 'react-select/creatable';
import voiceStore from '../../stores/voiceStore';
import { observer } from 'mobx-react';
import projectStore from '../../stores/projectStore';
import { FaTimes } from 'react-icons/fa';

const SelectTagsModal = observer(class SelectTagsModal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            selectedGender: props.selectedTags.gender || [],
            selectedLanguages: props.selectedTags.languages && props.selectedTags.languages[0]?.value ? props.selectedTags.languages : [],
            selectedAccents: props.selectedTags.accents && props.selectedTags.accents[0]?.value ? props.selectedTags.accents : [],
            selectedStyles: props.selectedTags.styles && props.selectedTags.styles[0]?.value ? props.selectedTags.styles : [],
            selectedAgeGroups: props.selectedTags.ageGroups && props.selectedTags.ageGroups[0]?.value ? props.selectedTags.ageGroups : [],
            selectedAdditionalTags: props.selectedTags.additionalTags && props.selectedTags.additionalTags[0]?.value ? props.selectedTags.additionalTags : []            
        };
    }
    
    handleGenderSelect = (data) => {
        this.setState({ selectedGender: data });
    };

    handleLanguageSelect = (data) => {
        this.setState({ selectedLanguages: data });
    };

    handleAccentSelect = (data) => {
        this.setState({ selectedAccents: data });
    };

    handleStyleSelect = (data) => {
        this.setState({ selectedStyles: data });
    };

    handleAgeGroupSelect = (data) => {
        this.setState({ selectedAgeGroups: data });
    };

    handleAdditionalTagsSelect = (data) => {
        this.setState({ selectedAdditionalTags: data });
    };

    handleSave = () => {
        const { selectedGender, selectedLanguages, selectedAccents, selectedStyles, selectedAgeGroups, selectedAdditionalTags } = this.state;
        this.props.onSave({
            gender: selectedGender,
            languages: selectedLanguages,
            accents: selectedAccents,
            styles: selectedStyles,
            ageGroups: selectedAgeGroups,
            additionalTags: selectedAdditionalTags
        });
    };

    render() {
     
        const { accentOptions, ageGroupOptions, genderOptions, languageOptions, styleOptions } = voiceStore.normalDropdownData
        return (
            <div className="fixed inset-0 flex flex-1 w-full items-center overflow-y-scroll lg:overflow-hidden justify-center bg-black bg-opacity-50 z-10">
                <div className="flex relative flex-col w-full lg:w-[80%] bg-white p-6 rounded-lg shadow-lg pt-24 lg:pt-0">
                    <h2 className="font-bold text-3xl text-[#21272A] mb-4 pt-6">{`Select Tag(s)`}</h2>
                    <span className="font-normal text-base text-[#21272A]">Select Tags</span>
                    <FaTimes onClick={this.props.onClose} className='absolute right-5 top-5 hover:cursor-pointer' size={20} color='black'></FaTimes>

                    <div className="flex flex-1 flex-col lg:flex-row w-full gap-3 mt-14">
                        <div className="flex flex-col flex-1">
                            <span className="font-semibold text-base text-[#21272A] mb-2">Gender</span>
                            <div>
                                <Select
                                    options={genderOptions}
                                    placeholder=""
                                    value={this.state.selectedGender}
                                    onChange={this.handleGenderSelect}
                                    isSearchable={true}
                                    styles={{
                                        control: (provided) => ({
                                            ...provided,
                                            backgroundColor: '#F0EFEF',
                                            color: '#FFF',
                                            paddingTop: 5,
                                            paddingBottom: 5,
                                            boxShadow: 'none',
                                            border: '1px solid #ccc',
                                            '&:hover': {
                                                border: '1px solid #ccc'
                                            }
                                        }),
                                        indicatorsContainer: (provided) => ({
                                            ...provided,
                                            display: 'none'
                                        }),
                                        multiValue: (provided) => ({
                                            ...provided,
                                            backgroundColor: '#B7B7B7',
                                            borderRadius: 6
                                        }),
                                        multiValueLabel: (provided) => ({
                                            ...provided,
                                            color: '#130D0D',
                                            paddingRight: 10,
                                            paddingLeft: 16,
                                            paddingTop: 10,
                                            paddingBottom: 10
                                        }),
                                        multiValueRemove: (provided) => ({
                                            ...provided,
                                            color: '#130D0D',
                                            ':hover': {
                                                backgroundColor: '#B7B7B7',
                                                color: '#130D0D',
                                                borderRadius: 6
                                            }
                                        })
                                    }}
                                />
                            </div>
                        </div>

                        <div className="flex flex-col flex-1">
                            <span className="font-semibold text-base text-[#21272A] mb-2">Language</span>
                            <div>
                                <Select
                                    options={languageOptions}
                                    placeholder=""
                                    value={this.state.selectedLanguages}
                                    onChange={this.handleLanguageSelect}
                                    isSearchable={true}
                                    isMulti
                                    styles={{
                                        control: (provided) => ({
                                            ...provided,
                                            backgroundColor: '#F0EFEF',
                                            color: '#FFF',
                                            paddingTop: 5,
                                            paddingBottom: 5,
                                            boxShadow: 'none',
                                            border: '1px solid #ccc',
                                            '&:hover': {
                                                border: '1px solid #ccc'
                                            }
                                        }),
                                        indicatorsContainer: (provided) => ({
                                            ...provided,
                                            display: 'none'
                                        }),
                                        multiValue: (provided) => ({
                                            ...provided,
                                            backgroundColor: '#B7B7B7',
                                            borderRadius: 6
                                        }),
                                        multiValueLabel: (provided) => ({
                                            ...provided,
                                            color: '#130D0D',
                                            paddingRight: 10,
                                            paddingLeft: 16,
                                            paddingTop: 10,
                                            paddingBottom: 10
                                        }),
                                        multiValueRemove: (provided) => ({
                                            ...provided,
                                            color: '#130D0D',
                                            ':hover': {
                                                backgroundColor: '#B7B7B7',
                                                color: '#130D0D',
                                                borderRadius: 6
                                            }
                                        })
                                    }}
                                />
                            </div>
                        </div>

                        <div className="flex flex-col flex-1">
                            <span className="font-semibold text-base text-[#21272A] mb-2">Accent</span>
                            <div>
                                <Select
                                    options={accentOptions}
                                    placeholder=""
                                    value={this.state.selectedAccents}
                                    onChange={this.handleAccentSelect}
                                    isSearchable={true}
                                    isMulti
                                    styles={{
                                        control: (provided) => ({
                                            ...provided,
                                            backgroundColor: '#F0EFEF',
                                            color: '#FFF',
                                            paddingTop: 5,
                                            paddingBottom: 5,
                                            boxShadow: 'none',
                                            border: '1px solid #ccc',
                                            '&:hover': {
                                                border: '1px solid #ccc'
                                            }
                                        }),
                                        indicatorsContainer: (provided) => ({
                                            ...provided,
                                            display: 'none'
                                        }),
                                        multiValue: (provided) => ({
                                            ...provided,
                                            backgroundColor: '#B7B7B7',
                                            borderRadius: 6
                                        }),
                                        multiValueLabel: (provided) => ({
                                            ...provided,
                                            color: '#130D0D',
                                            paddingRight: 10,
                                            paddingLeft: 16,
                                            paddingTop: 10,
                                            paddingBottom: 10
                                        }),
                                        multiValueRemove: (provided) => ({
                                            ...provided,
                                            color: '#130D0D',
                                            ':hover': {
                                                backgroundColor: '#B7B7B7',
                                                color: '#130D0D',
                                                borderRadius: 6
                                            }
                                        })
                                    }}
                                />
                            </div>
                        </div>

                        <div className="flex flex-col flex-1">
                            <span className="font-semibold text-base text-[#21272A] mb-2">Age</span>
                            <div>
                                <Select
                                    options={ageGroupOptions}
                                    placeholder=""
                                    value={this.state.selectedAgeGroups}
                                    onChange={this.handleAgeGroupSelect}
                                    isSearchable={true}
                                    isMulti
                                    styles={{
                                        control: (provided) => ({
                                            ...provided,
                                            backgroundColor: '#F0EFEF',
                                            color: '#FFF',
                                            paddingTop: 5,
                                            paddingBottom: 5,
                                            boxShadow: 'none',
                                            border: '1px solid #ccc',
                                            '&:hover': {
                                                border: '1px solid #ccc'
                                            }
                                        }),
                                        indicatorsContainer: (provided) => ({
                                            ...provided,
                                            display: 'none'
                                        }),
                                        multiValue: (provided) => ({
                                            ...provided,
                                            backgroundColor: '#B7B7B7',
                                            borderRadius: 6
                                        }),
                                        multiValueLabel: (provided) => ({
                                            ...provided,
                                            color: '#130D0D',
                                            paddingRight: 10,
                                            paddingLeft: 16,
                                            paddingTop: 10,
                                            paddingBottom: 10
                                        }),
                                        multiValueRemove: (provided) => ({
                                            ...provided,
                                            color: '#130D0D',
                                            ':hover': {
                                                backgroundColor: '#B7B7B7',
                                                color: '#130D0D',
                                                borderRadius: 6
                                            }
                                        })
                                    }}
                                />
                            </div>

                        </div>

                        <div className="flex flex-col flex-1">
                            <span className="font-semibold text-base text-[#21272A] mb-2">Style</span>
                            <div>
                                <Select
                                    options={styleOptions}
                                    placeholder=""
                                    value={this.state.selectedStyles}
                                    onChange={this.handleStyleSelect}
                                    isSearchable={true}
                                    isMulti
                                    styles={{
                                        control: (provided) => ({
                                            ...provided,
                                            backgroundColor: '#F0EFEF',
                                            color: '#FFF',
                                            paddingTop: 5,
                                            paddingBottom: 5,
                                            boxShadow: 'none',
                                            border: '1px solid #ccc',
                                            '&:hover': {
                                                border: '1px solid #ccc'
                                            }
                                        }),
                                        indicatorsContainer: (provided) => ({
                                            ...provided,
                                            display: 'none'
                                        }),
                                        multiValue: (provided) => ({
                                            ...provided,
                                            backgroundColor: '#B7B7B7',
                                            borderRadius: 6
                                        }),
                                        multiValueLabel: (provided) => ({
                                            ...provided,
                                            color: '#130D0D',
                                            paddingRight: 10,
                                            paddingLeft: 16,
                                            paddingTop: 10,
                                            paddingBottom: 10
                                        }),
                                        multiValueRemove: (provided) => ({
                                            ...provided,
                                            color: '#130D0D',
                                            ':hover': {
                                                backgroundColor: '#B7B7B7',
                                                color: '#130D0D',
                                                borderRadius: 6
                                            }
                                        })
                                    }}
                                />
                            </div>
                        </div>

                        <div className="flex flex-col flex-1">
                            <span className="font-semibold text-base text-[#21272A] mb-2">Custom Tags</span>

                            <div>
                                <CreatableSelect
                                    placeholder="Enter text..."
                                    value={this.state.selectedAdditionalTags}
                                    onChange={this.handleAdditionalTagsSelect}
                                    isSearchable={true}
                                    isMulti
                                    styles={{
                                        control: (provided) => ({
                                            ...provided,
                                            backgroundColor: '#F0EFEF',
                                            color: '#FFF',
                                            paddingTop: 5,
                                            paddingBottom: 5,
                                            boxShadow: 'none',
                                            border: '1px solid #ccc',
                                            '&:hover': {
                                                border: '1px solid #ccc'
                                            }
                                        }),
                                        indicatorsContainer: (provided) => ({
                                            ...provided,
                                            display: 'none'
                                        }),
                                        multiValue: (provided) => ({
                                            ...provided,
                                            backgroundColor: '#B7B7B7',
                                            borderRadius: 6
                                        }),
                                        multiValueLabel: (provided) => ({
                                            ...provided,
                                            color: '#130D0D',
                                            paddingRight: 10,
                                            paddingLeft: 16,
                                            paddingTop: 10,
                                            paddingBottom: 10
                                        }),
                                        multiValueRemove: (provided) => ({
                                            ...provided,
                                            color: '#130D0D',
                                            ':hover': {
                                                backgroundColor: '#B7B7B7',
                                                color: '#130D0D',
                                                borderRadius: 6
                                            }
                                        })
                                    }}
                                />
                            </div>
                        </div>
                    </div>

                    <div className="mt-24 flex justify-end gap-2">
                        <button
                            className="text-[#F89A1F] font-medium text-base px-6 py-2 rounded-md border-[2px] border-[#F89A1F]"
                            onClick={() => {
                                projectStore.setAddTagsModalVisible(true)
                            }}
                        >
                            Add More Tags
                        </button>
                        <button
                            className="text-[#130D0D] font-medium text-base px-6 py-2 rounded-md border-[2px] border-[#130D0D]"
                            onClick={this.props.onClose}
                        >
                            Back
                        </button>
                        <button
                            className="text-white font-medium text-base px-6 py-2 rounded-md bg-[#130D0D]"
                            onClick={this.handleSave}
                        >
                            Update
                        </button>
                    </div>
                </div>
            </div>
        );
    }
})

export default SelectTagsModal
